<template>
  <div>
    <b-modal id="modalEditRadiusAccountsSetting" ref="modalEditRadiusAccountsSetting" :title="$t('RADIUS account')" hide-footer @shown="shown" size="lg">
      <div v-if="editItem">
        <b-tabs vertical pills card>
          <b-tab :title="$t('Main')">
            <b-form-group label-align="right" v-if="editItem.id != 0" label="ID" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="editItem.id" disabled/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="editItem.name" aria-describedby="inputFeedbackName" :state="editItem.name.length > 0"/>
              <b-form-invalid-feedback id="inputFeedbackName">
                {{ $t('Enter title') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Password')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="editItem.password"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Include NAS attributes')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-checkbox v-model="editItem.add_nas_attributes"/>
            </b-form-group>
          </b-tab>
          <b-tab :title="$t('Set RADIUS parameters')">
            <md-button class="md-raised" @click="swohAddRadiusAttr" >{{ $t('Add') }}</md-button>
            <b-table small striped hover :items="radiusAttrItems" :fields="radiusAttrFields">
              <template v-slot:cell(actions)="row">
                <i @click.stop="ClickOnEditRadiusAttrButton(row)" class="primary fa fa-edit fa-lg" />
                <i @click.stop="deleteRadiusAttr(row)" class="danger fa fa-trash-alt fa-lg" />
              </template>
            </b-table>
          </b-tab>
        </b-tabs>

        <modal-ok-cancel @save="save" @cancel="$bvModal.hide('modalEditRadiusAccountsSetting')" size="lg"/>
      </div>
    </b-modal>

    <b-modal hide-footer :title="$t('Radius parameters')" ref="modalRadiusAttr" size="lg">
      <FormRadiusAttributs
      @hideAddRadiusAttr="hideAddRadiusAttr"
      :isEditRadiusAttr="isEditRadiusAttr"
      :isRadiusAccounts="isRadiusAccounts"
      :rowRadiusAttr="rowRadiusAttr"
      :radiusAttrItems="radiusAttrItems"/>
    </b-modal>
  </div>
</template>

<script>
import FormRadiusAttributs from '@/pages/tariffication/servicesAndTariffs/formRadiusAttributs'

export default {
  components: {
    FormRadiusAttributs
  },
  props: {
    editItem: null
  },
  data () {
    return {
      isRadiusAccounts: true,
      radiusAttr: {
        'set_object_id': 0,
        'set_type': 12,
        'attrs': []
      },
      isEditRadiusAttr: false,
      rowRadiusAttr: null,
      radiusAttrItems: [],
      radiusAttrFields: [
        {key: 'vendor', label: this.$i18n.t('Vendor'), sortable: true},
        {key: 'code', label: this.$i18n.t('Attribute'), sortable: true},
        {key: 'value', label: this.$i18n.t('Value'), sortable: true},
        {key: 'attrType', label: this.$i18n.t('Type'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      editImage: require('@/assets/img/document_edit.png'),
      deleteImage: require('@/assets/img/document_delete.png')
    }
  },
  methods: {
    save () {
      if (!this.editItem.name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Full name fields is invalid'), 'Error')
        return
      }

      this.editItem.account_id = this.editItem.id
      let response = this.editItem.id !== 0
        ? this.$store.dispatch('Settings/UPDATE_RADIUS_ACCOUNTS', this.editItem)
        : this.$store.dispatch('Settings/CREATE_RADIUS_ACCOUNTS', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          if (this.editItem.id) {
            this.radiusAttr.set_object_id = this.editItem.id
          } else {
            this.radiusAttr.set_object_id = response.data.account_id
          }
          this.radiusAttr.attrs = this.radiusAttrItems
          this.$store.dispatch('Tariffing/UPDATE_RADIUS_ATTR', this.radiusAttr)
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_RADIUS_ACCOUNTS')
          this.$refs.modalEditRadiusAccountsSetting.hide()
          this.$root.$emit('makeToasts')
        }
      })
    },
    shown () {
      if (this.editItem.id) {
        this.$store.dispatch('Tariffing/GET_RADIUS_ATTR_ACCOUNTS', this.editItem.id)
        this.radiusAttrItems = this.$store.getters['Tariffing/RADIUS_ATTR_ACCOUNTS']
        for (let i in this.radiusAttrItems) {
          this.radiusAttrItems[i].value = this.radiusAttrItems[i].attr_value
          if (this.radiusAttrItems[i].tag && (this.radiusAttrItems[i].vendor === 0)) {
            this.radiusAttrItems[i].value = ':' + this.radiusAttrItems[i].tag + ':' + this.radiusAttrItems[i].attr_value
          }
          switch (this.radiusAttrItems[i].attr_type) {
            case 1:
              this.radiusAttrItems[i].attrType = this.$i18n.t('Number')
              break
            case 2:
              this.radiusAttrItems[i].attrType = this.$i18n.t('String')
              break
            case 3:
              this.radiusAttrItems[i].attrType = 'IP'
              break
            case 4:
              this.radiusAttrItems[i].attrType = this.$i18n.t('Binary')
              break
          }
        }
      }
    },
    deleteParam (item) {
      this.parameters = this.parameters.filter((el, idx, arr) => {
        return el.num !== item.num
      })
    },
    deleteRadiusAttr (row) {
      this.rowRadiusAttr = row.item
      this.radiusAttrItems = this.radiusAttrItems.filter((value) => {
        return value !== this.rowRadiusAttr
      })
    },
    swohAddRadiusAttr () {
      this.rowRadiusAttr = null
      this.isEditRadiusAttr = false
      this.$refs.modalRadiusAttr.show()
    },
    ClickOnEditRadiusAttrButton (row) {
      this.rowRadiusAttr = row.item
      this.isEditRadiusAttr = true
      this.$refs.modalRadiusAttr.show()
    },
    hideAddRadiusAttr () {
      this.$refs.modalRadiusAttr.hide()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/settings/system/radiusAccounts/editModal.vue